import { render, staticRenderFns } from "./DetailsForm.vue?vue&type=template&id=01bfb4c0&scoped=true"
import script from "./DetailsForm.vue?vue&type=script&lang=js"
export * from "./DetailsForm.vue?vue&type=script&lang=js"
import style0 from "./DetailsForm.vue?vue&type=style&index=0&id=01bfb4c0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfb4c0",
  null
  
)

export default component.exports